export default __webpack_public_path__ + "static/media/Comforter-Regular.958af506.ttf";